import { render, staticRenderFns } from "./SelectedProducerOrGroup.vue?vue&type=template&id=2671c39e&scoped=true&"
import script from "./SelectedProducerOrGroup.vue?vue&type=script&lang=js&"
export * from "./SelectedProducerOrGroup.vue?vue&type=script&lang=js&"
import style0 from "./SelectedProducerOrGroup.vue?vue&type=style&index=0&id=2671c39e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2671c39e",
  null
  
)

export default component.exports